module.exports = __webpack_public_path__ + "static/img/ISSGS.e9c71d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ISSGS.png
// module id = As7T
// module chunks = 1